import React from 'react'

const NewsSource = ({source}) => {
  return (
    <div className="source">
    <p>{source}</p>
      </div>
   
  )
}

export default NewsSource